import React, { useState, useEffect } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import "../../styles/App.css";

const StudentForm = () => {
  const [pib, setPib] = useState("");
  const [group, setGroup] = useState("");
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState("");
  const [rating, setRating] = useState(0); 
  const [benefit, setBenefit] = useState(""); 
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const API = process.env.REACT_APP_API_BASE;

  const fetchRooms = async () => {
    try {
      const response = await fetch(`${API}/api/available-rooms`, {
        headers: { Authorization: getAuthHeader() },
      });
      const data = await response.json();
      setRooms(data);
    } catch (error) {
      console.error("Помилка завантаження кімнат:", error);
    }
  };

  useEffect(() => {
    fetchRooms();
  }, []);
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API}/api/students`, {
        method: "POST",
        headers: {
          Authorization: getAuthHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pib,
          group,
          room_id: selectedRoom,
          rating,
          benefit,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
        setError("");
        setPib("");
        setGroup("");
        setSelectedRoom("");
        setRating(0);
        setBenefit("");

        await fetchRooms(); // оновлює список актуальних кімнат
      } else {
        setError(data.error || "Не вдалося додати студента.");
        setMessage("");
      }
    } catch (error) {
      console.error("Помилка:", error);
      setError("Помилка сервера. Спробуйте пізніше.");
      setMessage("");
    }
  };

  return (
    <div className="page-container">
      <form onSubmit={handleSubmit} className="input-component">
        <div className="form-container">
          <label htmlFor="pib" className="input-block text-header">
            ПІБ:
            <input
              className="input-component-with-border"
              type="text"
              id="pib"
              placeholder="Введіть піб студента"
              value={pib}
              onChange={(e) => setPib(e.target.value)}
              required
            />
          </label>

          <label htmlFor="group" className="input-block text-header">
            Група:
            <input
              className="input-component-with-border"
              type="text"
              id="group"
              placeholder="Введіть групу студента"
              value={group}
              onChange={(e) => setGroup(e.target.value)}
              required
            />
          </label>

          <label htmlFor="roomId" className="input-block text-header">
            Оберіть кімнату:
            <select
              className="input-component-with-border"
              id="roomId"
              value={selectedRoom}
              onChange={(e) => setSelectedRoom(e.target.value)}
              required
            >
              <option value="">Оберіть кімнату</option>
              {[...rooms]
                .sort((a, b) =>
                  `${a.dormitory_name} ${a.room_number}`.localeCompare(
                    `${b.dormitory_name} ${b.room_number}`
                  )
                )
                .map((room) => (
                  <option key={room.id} value={room.id}>
                    {`${room.dormitory_name} - ${room.room_number} (вільних ліжок: ${room.free_beds})`}
                  </option>
                ))}
            </select>
          </label>
        </div>
        <div className="form-container">
          <label className="input-block text-header">
            Рейтинг:
            <input
              className="input-component-with-border"
              type="number"
              value={rating}
              onChange={(e) => setRating(e.target.value)}
              placeholder="Введіть рейтинг студента"
            />
          </label>
          <label className="input-block text-header">
            Пільга:
            <input
              className="input-component-with-border"
              type="text"
              value={benefit}
              onChange={(e) => setBenefit(e.target.value)}
              placeholder="Введіть пільгу або залиште порожнім"
            />
          </label>
        </div>

        <button
          type="submit"
          disabled={!selectedRoom}
          className="submit-button"
        >
          Додати студента
        </button>
      </form>

      {message && <p style={{ color: "green" }}>{message}</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default StudentForm;
